import { render } from "./UIButtonToggle.vue?vue&type=template&id=0e722486&scoped=true"
import script from "./UIButtonToggle.vue?vue&type=script&lang=ts"
export * from "./UIButtonToggle.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-0e722486"

export default script